// @flow
export const constructGraphqlError = (e: string): Promise<*> =>
  Promise.reject({
    graphQLErrors: [{message: 'Passwords must be same'}],
  });

export const errorCodes = {
  TENANT_NOT_ALLOWED: 'E_TENANT_NOT_ALLOWED',
};
